export function wordToReadableText(enumStr: string): string {
  const text = enumStr.toLowerCase();
  // Capitalize the first letter of each word and join them
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function toReadableText(enumStr: string): string {
  if (enumStr.length === 0) {
    return "";
  } else {
    const words = enumStr.split("_");
    const readableWords = words.map((word) => wordToReadableText(word));
    return readableWords.join(" ");
  }
}

export function extractHashtags(text: string): string[] {
  // Regular expression to match hashtags
  const hashtagRegex = /#(\w+)/g;

  // Find all matches
  const matches = text.match(hashtagRegex);

  if (!matches) {
    return [];
  }

  // Remove the '#' symbol and create a unique set of hashtags
  const uniqueHashtags = new Set(matches.map((tag) => tag.slice(1)));

  // Convert the set back to an array
  return Array.from(uniqueHashtags);
}

/**
 * Removes all hashtags from a given string.
 * @param text - The input string containing hashtags.
 * @returns A new string with all hashtags removed.
 */
export function removeHashtags(text: string): string {
  // Regular expression to match hashtags
  const hashtagRegex = /#\S+\s?/g;

  // Replace all occurrences of hashtags with an empty string
  return text.replace(hashtagRegex, "").trim();
}

export function trimText(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength - 3) + "...";
}
